import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevronRightBold = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 9,
	height: 12,
	viewBox: "0 0 9 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M2.20492 0L0.794922 1.41L5.37492 6L0.794922 10.59L2.20492 12L8.20492 6L2.20492 0Z",
		fill: "currentColor"
	})
});
const ForwardRef = forwardRef(SvgChevronRightBold);
export { ForwardRef as ReactComponent };
